import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, QueryList, ContentChild } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { ChartComponent } from '@progress/kendo-angular-charts';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';

@Component({
    selector: 'ls-chart-picker',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './chart-picker.component.html',
    styleUrls: ['./chart-picker.component.scss'],
    standalone: true,
    imports: [NgIf, MatCheckboxModule, MatButtonModule, MatTooltipModule, MatIconModule]
})
export class ChartPickerComponent {

    @ContentChild(ChartComponent) chart!: QueryList<ChartComponent>;

    @Output() change = new EventEmitter<boolean>();
    @Output() saveAs = new EventEmitter<void>();
    @Input() enabled: boolean = false;
    @Input() selected: boolean = false;
    @Input() helper;

    select(e: MatCheckboxChange) {
        this.change.emit(e.checked);
    }

    ngAfterContentInit() {
        // console.log(this.chart);
    }

}
